import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../../utils/api";
import "./Tablestock.css";

const makeStyle = (status) => {
  switch (status) {
    case "active":
      return { color: "green", fontWeight: "bold" };
    case "expired":
      return { color: "red", fontWeight: "bold" };
    case "inactive":
      return { color: "orange", fontWeight: "bold" };
    case "completed":
      return { color: "blue", fontWeight: "bold" };
    default:
      return {};
  }
};

export default function PrimeProductTable({ searchQuery }) {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return isNaN(date.getTime())
      ? "N/A"
      : date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
  };

  const routeChange = (batchId) => {
    window.location.href = `/inventory/batchdetails/${batchId}`;
  };

  useEffect(() => {
    const fetchBatches = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/batch/batchDetails`);
        setBatches(res.data);
      } catch (err) {
        console.error("Error fetching batches:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchBatches();
  }, []);

  const statusBodyTemplate = (rowData) => (
    <span style={makeStyle(rowData.status)}>{rowData.status}</span>
  );

  const filteredBatches = batches.filter((batch) =>
    [
      batch.batchNumber,
      batch.product?.productName,
      formatDate(batch.manufactureDate),
      formatDate(batch.expiryDate),
      formatDate(batch.createdAt),
      batch.status,
      batch.warehouse,
      batch.rack
    ].some((field) =>
      field?.toString().toLowerCase().includes(searchQuery?.toLowerCase() || "")
    )
  );
  const responsiveColumnHeader = (header) => (rowData, { field }) => (
    <div className="responsive-cell">
      <span className="responsive-header">{header}</span>
      <span className="responsive-value">
        {field === "productName"
          ? rowData.product?.productName || "N/A"
          : field === "manufactureDate"
            ? formatDate(rowData.manufactureDate)
            : field === "expiryDate"
              ? formatDate(rowData.expiryDate)
              : field === "createdAt"
                ? formatDate(rowData.createdAt)
                : field === "status"
                  ? statusBodyTemplate(rowData)
                  : rowData[field]}
      </span>
    </div>
  );



  return (
    <div className="datatable-wrapper">
      <DataTable
        value={filteredBatches}
        paginator
        rows={rows}
        first={first}
        onPage={(e) => {
          setFirst(e.first);
          setRows(e.rows);
        }}
        onRowClick={(e) => routeChange(e.data._id)}
        loading={loading}
        responsiveLayout="stack"
        scrollable
        scrollHeight="450px"
        selectionMode="single"
        emptyMessage="No results found"
        stripedRows
        className="datatable-scrollable"
      >
        <Column
          field="batchNumber"
          header="Batch Number"
          body={responsiveColumnHeader("Batch Number")}
          sortable
        />
        <Column
          field="productName"
          header="Product Name"
          body={responsiveColumnHeader("Product Name")}
          sortable
        />
        <Column
          field="manufactureDate"
          header="Manufacture Date"
          body={responsiveColumnHeader("Manufacture Date")}
          sortable
        />
        <Column
          field="expiryDate"
          header="Expiry Date"
          body={responsiveColumnHeader("Expiry Date")}
          sortable
        />
        <Column
          field="createdAt"
          header="Created At"
          body={responsiveColumnHeader("Created At")}
          sortable
        />
         <Column
          field="warehouse"
          header="Warehouse"
          body={responsiveColumnHeader("Warehouse")}
          sortable
        />
         <Column
          field="rack"
          header="Rack"
          body={responsiveColumnHeader("Rack")}
          sortable
        />
        <Column
          field="status"
          header="Status"
          body={responsiveColumnHeader("Status")}
          sortable
        />
      </DataTable>
    </div>
  );
}
